<template>
  <div class="design-thumbnail cursor-pointer flex flex-col" @click="$emit('click', slug)">
    <div class="h-full">
      <!-- TODO Dynamic alt tag (e.g. Glory men originals thumbnail)-->
      <OImage
        v-if="image"
        img-class="w-full h-full rounded-t-custom"
        :desktop="image.desktop"
        :mobile="image.mobile"
        :src="image.fallback"
        :alt="$t('Accessibilty.AltTags.PhotoOfTheDesignWithName', { name: name })"
      />
    </div>
    <div class="design-thumbnail-info flex justify-between p-3 text-white rounded-b-custom" :style="{ 'background-color': `rgb(${color})` }">
      <span v-if="name" class="ota-body-light font-semibold" v-text="name" />
      <span v-if="date" class="ota-body-light" v-text="$t(`Months[${date - 1}]`)" />
    </div>
  </div>
</template>

<script>
const OImage = () => import('@/components/OImage')

export default {
  name: 'DesignThumbnail',
  components: {
    OImage
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '130, 130, 130'
    },
    image: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="postcss" scoped>
.oimage >>> img {
  max-width: 100%;
  @apply object-cover !important;
}

>>> .rounded-t-custom {
  border-top-left-radius: .8rem;
  border-top-right-radius: .8rem;
}

.rounded-b-custom {
  border-bottom-left-radius: .8rem;
  border-bottom-right-radius: .8rem;
}

@screen md {
  .design-thumbnail-info {
    @apply bg-gray-400 !important;
  }
}
</style>
